/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { ContentAdminRetrieve } from './ContentAdminRetrieve'
import {
  ContentAdminRetrieveFromJSON,
  ContentAdminRetrieveFromJSONTyped,
  ContentAdminRetrieveToJSON,
} from './ContentAdminRetrieve'

/**
 *
 * @export
 * @interface EnvelopedContentContentAdminRetrieve
 */
export interface EnvelopedContentContentAdminRetrieve {
  /**
   *
   * @type {ContentAdminRetrieve}
   * @memberof EnvelopedContentContentAdminRetrieve
   */
  body: ContentAdminRetrieve
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedContentContentAdminRetrieve
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedContentContentAdminRetrieve interface.
 */
export function instanceOfEnvelopedContentContentAdminRetrieve(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedContentContentAdminRetrieveFromJSON(
  json: any,
): EnvelopedContentContentAdminRetrieve {
  return EnvelopedContentContentAdminRetrieveFromJSONTyped(json, false)
}

export function EnvelopedContentContentAdminRetrieveFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedContentContentAdminRetrieve {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: ContentAdminRetrieveFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedContentContentAdminRetrieveToJSON(
  value?: EnvelopedContentContentAdminRetrieve | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: ContentAdminRetrieveToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
